<template>
<b-tab lazy title-item-class="mb-1" class="p-0">
    <template slot="title">Forms</template>
    <forms-base />
</b-tab>
</template>

<script>
import TabExtension from "./TabExtension"
import FormsBase from "./FormsBase"

export default TabExtension.extend({
    name: "patient-forms",
    components: {
        FormsBase
    },
})
</script>
